"use client";

import React, {useEffect} from "react";
import {Bot} from "lucide-react";
import {
    ExpandableChat,
    ExpandableChatHeader,
    ExpandableChatBody,
    ExpandableChatFooter,
} from "@/components/ui/chat/expandable-chat";
import {useAuth} from "@/util/auth";
import {formatName} from "@/util/format";
import Balancer from "react-wrap-balancer";
import Image from 'next/image';
import Script from "next/script";

export default function Chat() {
    const auth = useAuth();
    const user = auth.user;

    if (!user || !auth.isAuthenticated) {
        return null;
    }

    return (
        <>
            <Script id="docsbot-bootstrap" strategy="afterInteractive">
            {`
              window.DocsBotAI=window.DocsBotAI||{},DocsBotAI.init=function(e){return new Promise((t,r)=>{var n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://widget.docsbot.ai/chat.js";let o=document.getElementsByTagName("script")[0];o.parentNode.insertBefore(n,o),n.addEventListener("load",()=>{let n;Promise.all([new Promise((t,r)=>{window.DocsBotAI.mount(Object.assign({}, e)).then(t).catch(r)}),(n=function e(t){return new Promise(e=>{if(document.querySelector(t))return e(document.querySelector(t));let r=new MutationObserver(n=>{if(document.querySelector(t))return e(document.querySelector(t)),r.disconnect()});r.observe(document.body,{childList:!0,subtree:!0})})})("#docsbotai-root"),]).then(()=>t()).catch(r)}),n.addEventListener("error",e=>{r(e.message)})})};
            `}
            </Script>
            <Script id="docsbot-init" strategy="afterInteractive">
            {`
              DocsBotAI.init({id: "JOhmHrJd58lqQ5E2feY4/tdBR2YQL8uWzgZP1Fq32", options: {hideHeader: true, inputLimit: 2000}});
            `}
            </Script>
            <ExpandableChat
                icon={<img src="/media/chat/casey-avatar2.webp" width={200} height={200} alt="Casey Avatar" className="h-14 w-14 rounded overflow-hidden" />}
                size="lg"
                position="bottom-right"
                userName={formatName(user)}
            >
                <ExpandableChatHeader className="flex-col text-center justify-center bg-teal-200">
                    <h1 className="text-md font-semibold flex flex-col">
                        <span>How can I help you today?</span>
                    </h1>
                </ExpandableChatHeader>
                <ExpandableChatBody>
                    <div id="docsbot-widget-embed" style={{
                        overflowX: 'hidden',
                        height: '100%'
                    }}></div>
                </ExpandableChatBody>
                <ExpandableChatFooter className="flex justify-center p-2">
                    <p className="text-xs text-muted-foreground">This is an AI-powered assistant.</p>
                </ExpandableChatFooter>
            </ExpandableChat></>
    );
}